import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { Header, DataContainer, FlexDiv } from './styles';
import {
  DocListOverlay,
  CloseIcon,
  ContentContainer,
  StepsContainer,
  CountWrapper,
  DocListFooter,
  CountWrapperContainer,
} from './overlayScreenStyles';
import { Filters } from './filterSectionStyles';
import { PrinterCardDesign } from './printerListStyles';
import { Icon, Steps, Button, Input, message } from 'antd';
import FiltersContainer from './FilterSection';
import DocumentList from './DocumentList';
import PrinterList from './PrinterList';
import { MailRoomContext } from '../../context/mailRoomContext';
import { createNewBatch } from '../../utils/services/mailRoomAPI';
import { getWeek } from '../../utils/javascript';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { withTranslation } from 'react-i18next';
import { FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP } from './translationValues';

const NAMESPACES = ['FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP'];

const { Step } = Steps;
const { Search } = Input;

const CreateBatch = ({ setCreateBatch, setDefaultWeek, t }) => {
  const [batchName, setBatchName] = useState('');
  const [description, setDescription] = useState('');
  const [currentStep, setCurrentStep] = useState(0);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedPrinter, setSelectedPrinter] = useState(undefined);
  const [printerSearchText, setPrinterSearchText] = useState('');
  const [selectedPrinterName, setSelectedPrinterName] = useState('');

  const batchNameRef = useRef();

  const LIMIT = window.innerHeight > 1000 ? 24 : window.innerHeight > 800 ? 16 : 12;

  const {
    searchByDocName,
    payloadTags,
    startAndEndDate,
    setStartAndEndDate,
    pageFilter,
    docsCount,
    pagesCount,
    clearAllFilters,
  } = useContext(MailRoomContext);

  const escFunction = useCallback(
    event => {
      if (event.key === 'Escape') {
        clearAllFilters();
        setCreateBatch(false);
        setDefaultWeek();
      }
    },
    [setCreateBatch, setDefaultWeek, clearAllFilters],
  );

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    let startAndEndDate = getWeek();
    let dates = {
      startDate: startAndEndDate.startDate,
      endDate: startAndEndDate.endDate,
    };
    setStartAndEndDate(dates);
  }, []);

  useEffect(() => {
    if (batchNameRef && batchNameRef.current !== undefined) batchNameRef.current.focus();
  }, []);

  const onPrint = async () => {
    setIsPrinting(true);
    let payload = {
      name: batchName,
      description: description,
      dateFrom: startAndEndDate.startDate,
      dateTo: startAndEndDate.endDate,
      printerId: selectedPrinter,
      printerName: selectedPrinterName,
    };
    if (searchByDocName) {
      payload.nameSearched = searchByDocName;
    }
    if (Object.keys(payloadTags).length > 0) {
      payload = { ...payload, ...payloadTags };
    }
    if(pageFilter) {
      payload.documentPages = parseInt(pageFilter);
    }
    const response = await createNewBatch(payload);
    if (response) {
      if (response.errors && response.errors.length === 0 && response.statusCode !== 1545) {
        let newBatchName = response?.data?.name ? response?.data?.name : '';
        message.success(
          ` ${t(
            FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.BATCH_CREATED_SUCCESS_MESSAGE.key,
            FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.BATCH_CREATED_SUCCESS_MESSAGE.value,
            { batchName: newBatchName?.length > 0 && newBatchName },
          )}`,
        );
        setCreateBatch(false);
        setDefaultWeek();
        clearAllFilters();
      } else if (response.statusCode === 1545) {
        if (response.errors.length > 0) {
        } else {
          message.error(
            t(
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.UNABLE_TO_CREATE_ERROR_MESSAGE.key,
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.UNABLE_TO_CREATE_ERROR_MESSAGE.value,
            ),
          );
        }
      }
      setIsPrinting(false);
    }
  };

  return (
    <DocListOverlay>
      <Header isLoading={isLoading} padding="1.5rem" height="20vh" justifyContent={'space-between'}>
        <div className="batchInputs">
          <Input
            ref={batchNameRef}
            disabled={isLoading}
            className="editableBatchName"
            value={batchName}
            onChange={e => setBatchName(e.target.value)}
            placeholder={t(
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.BATCH_NAME_PLACEHOLDER.key,
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.BATCH_NAME_PLACEHOLDER.value,
            )}
          />
          <Input
            className="editableBatchDescription"
            disabled={isLoading}
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder={t(
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.BATCH_DESCRIPTION_PLACEHOLDER.key,
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.BATCH_DESCRIPTION_PLACEHOLDER.value,
            )}
          />
        </div>
        <FlexDiv isLoading={isLoading}>
          {currentStep === 0 ? (
            <FiltersContainer />
          ) : (
            <Filters>
              <div className="searchDoc">
                <Search
                  placeholder={t(
                    FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.SEARCH_PRINTERS_PLACEHOLDER.key,
                    FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.SEARCH_PRINTERS_PLACEHOLDER.value,
                  )}
                  value={printerSearchText}
                  onChange={e => setPrinterSearchText(e.target.value)}
                  allowClear
                  style={{ width: 200 }}
                />
              </div>
            </Filters>
          )}

          <CloseIcon>
            <Icon
              type="close"
              onClick={() => {
                clearAllFilters();
                setCreateBatch(false);
                setDefaultWeek();
              }}
            />
          </CloseIcon>
        </FlexDiv>
      </Header>
      <ContentContainer height={'70vh'}>
        <CountWrapperContainer>
          <CountWrapper>
            <div>
              <p>
                {t(
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.NUMBER_OF_DOCUMENTS_LABEL.key,
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.NUMBER_OF_DOCUMENTS_LABEL.value,
                )}
              </p>
              <h3>{docsCount}</h3>
            </div>
            <hr />
            <div>
              <p>
                {t(
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.NUMBER_OF_PAGES_LABEL.key,
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.NUMBER_OF_PAGES_LABEL.value,
                )}
              </p>
              <h3>{pagesCount}</h3>
            </div>
          </CountWrapper>
          <StepsContainer>
            <Steps direction="vertical" progressDot current={currentStep}>
              <Step
                title={t(
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.FILTER_DOCUMENT_TITLE.key,
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.FILTER_DOCUMENT_TITLE.value,
                )}
                description={t(
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.FILTER_DESCRIPTION.key,
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.FILTER_DESCRIPTION.value,
                )}
              />
              <Step
                title={t(
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.INITIATE_PRINT_TITLE.key,
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.INITIATE_PRINT_TITLE.value,
                )}
                description={t(
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.INITIATE_PRINT_DESCRIPTION.key,
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.INITIATE_PRINT_DESCRIPTION.value,
                )}
              />
            </Steps>
          </StepsContainer>
        </CountWrapperContainer>
        <DataContainer width={'80%'} height={'70vh'}>
          <SwitchTransition>
            <CSSTransition
              key={currentStep}
              addEndListener={(node, done) => {
                node.addEventListener('transitionend', done, false);
              }}
              classNames="fade"
            >
              {currentStep === 0 ? (
                <DocumentList
                  pageLimit={LIMIT}
                  isCentered
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                />
              ) : (
                currentStep === 1 && (
                  <PrinterCardDesign>
                    <PrinterList
                      isLoading={isLoading}
                      setIsLoading={setIsLoading}
                      selectedPrinter={selectedPrinter}
                      setSelectedPrinter={setSelectedPrinter}
                      printerSearchText={printerSearchText}
                      setPrinterSearchText={setPrinterSearchText}
                      selectedPrinterName={selectedPrinterName}
                      setSelectedPrinterName={setSelectedPrinterName}
                    />
                  </PrinterCardDesign>
                )
              )}
            </CSSTransition>
          </SwitchTransition>
        </DataContainer>
      </ContentContainer>
      <DocListFooter
        width={'80%'}
        justifyContent={'space-between'}
        isLoading={isLoading}
        height={'10vh'}
      >
        {currentStep === 0 ? (
          <Button
            type="primary"
            onClick={() =>
              docsCount >= 1
                ? setCurrentStep(1)
                : message.error(
                    t(
                      FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.UNAVAILABLE_DOCUMENTS_ERROR_MESSAGE
                        .key,
                      FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.UNAVAILABLE_DOCUMENTS_ERROR_MESSAGE
                        .value,
                    ),
                  )
            }
          >
            {t(
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.NEXT_BUTTON.key,
              FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.NEXT_BUTTON.value,
            )}
          </Button>
        ) : (
          currentStep === 1 && (
            <div>
              <Button onClick={() => setCurrentStep(0)}>
                {t(
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.PREVIEW_BUTTON.key,
                  FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.PREVIEW_BUTTON.value,
                )}
              </Button>
              <Button
                loading={isPrinting}
                className="customButton"
                onClick={() =>
                  selectedPrinter
                    ? onPrint()
                    : message.error(
                        t(
                          FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP
                            .PRINTER_NOT_SELECTED_ERROR_MESSAGE.key,
                          FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP
                            .PRINTER_NOT_SELECTED_ERROR_MESSAGE.value,
                        ),
                      )
                }
              >
                {isPrinting
                  ? t(
                      FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.PRINT_LOADING.key,
                      FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.PRINT_LOADING.value,
                    )
                  : t(
                      FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.PRINT_BUTTON.key,
                      FILTER_DOCUMENT_AND_INITIATE_PRTINT_STEP.PRINT_BUTTON.value,
                    )}
              </Button>
            </div>
          )
        )}
      </DocListFooter>
    </DocListOverlay>
  );
};

export default withTranslation(NAMESPACES)(CreateBatch);
